import './onboardingIllustration.css';

export type OnboardingIllustrationSize = 'hero' | 'compact';

export interface OnboardingIllustrationProps {
  src: string;
  /** `hero` for intro/result screens, `compact` for question steps. */
  size?: OnboardingIllustrationSize;
  /** `eager` for the artwork that is above the fold on the first paint. */
  loading?: 'eager' | 'lazy';
  className?: string;
}

/**
 * Decorative onboarding artwork. The question text always carries the meaning,
 * so the image stays out of the accessibility tree.
 */
export function OnboardingIllustration({
  src,
  size = 'compact',
  loading = 'eager',
  className = '',
}: OnboardingIllustrationProps) {
  const classes = ['onboarding-illustration', `onboarding-illustration--${size}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <img
      className={classes}
      src={src}
      alt=""
      aria-hidden
      loading={loading}
      decoding="async"
      draggable={false}
    />
  );
}
